




























































import { Component, Prop, Vue } from 'vue-property-decorator';

import { PlaceItem } from '@/models/items/place-item-model';
import { ProductItem } from '@/models/items/product-item-model';
import { GenericItem } from '@/models/items/generic-item-model';
import { ListModel } from '@/models/list-model';

import DynamicItemMap from '@/components/DynamicItemMap.vue';
import StaticItemMap from '@/components/StaticItemMap.vue';
import ItemStarWidget from '@/components/ItemStarWidget.vue';
import IframelyEmbed from '@/components/IframelyEmbed.vue';
import { ItemStarActions } from '@/actions/item-star-actions';
import { ListModelUtil } from '@/model-utils/list-model-util';
import { ItemModelUtil } from '@/model-utils/item-model-util';

import { UserModule } from '@/store/modules/user';
import {
  AbstractItemModel,
  ItemType
} from '@/models/items/abstract-item-model';

@Component({
  components: { StaticItemMap, ItemStarWidget, DynamicItemMap, IframelyEmbed }
})
export default class BigItemCard extends Vue {
  @Prop(Object) public item!: Object;
  @Prop(ListModel) public list!: ListModel;
  @Prop({ default: false }) debug: boolean;
  isStarred: boolean = false;

  public typedItem: AbstractItemModel = this.item as AbstractItemModel;

  get canEditList(): boolean {
    return ListModelUtil.canEditList(this.list, UserModule.currentUserId);
  }

  get isProductItem() {
    return this.typedItem.type === ItemType.Product.toString();
  }

  get isPlaceItem() {
    return this.typedItem.type === ItemType.Place.toString();
  }

  get canEdit(): boolean {
    return ListModelUtil.canEditList(this.list, UserModule.currentUserId);
  }

  get brandMake() {
    return (this.typedItem as ProductItem).brandMake;
  }

  get model() {
    return (this.typedItem as ProductItem).model;
  }

  get tags() {
    return this.typedItem.tags;
  }

  get image() {
    return this.typedItem.imageURL;
  }

  get title() {
    return this.typedItem.title;
  }

  get subtitle() {
    return this.typedItem.subtitle || this.typedItem.asMedia.artist;
  }

  get description(): string {
    return this.typedItem.description;
  }

  get linkDomain() {
    return ItemModelUtil.getLinkDomain(this.typedItem);
  }

  get urlDisplay() {
    const url = this.typedItem.url || '';
    const maxLength = 50;
    if (url.length > maxLength) {
      return url.slice(0, maxLength) + '...';
    } else {
      return url;
    }
  }

  created() {
    this.checkIsStarred().then(v => (this.isStarred = v));
  }

  get isLoggedIn() {
    return UserModule.isLoggedIn;
  }

  checkIsStarred(): Promise<boolean> {
    if (UserModule.currentUserId) {
      return ItemStarActions.isStarred({
        itemId: this.typedItem.id,
        userId: UserModule.currentUserId
      });
    }
    return Promise.resolve(false);
  }

  get singleAddressLine() {
    return ItemModelUtil.singleAddressLine(this.typedItem as PlaceItem);
  }

  get formattedPhoneNumber() {
    if (!(this.typedItem as PlaceItem).phonenumber) {
      return null;
    }
    return ItemModelUtil.formattedPhoneNumber(this.typedItem as PlaceItem);
  }

  get phoneNumberLink() {
    return ItemModelUtil.phoneNumberLink(this.typedItem as PlaceItem);
  }

  get mapsLink() {
    return (
      'https://www.google.com/maps/search/?api=1&query=' +
      encodeURIComponent(this.singleAddressLine)
    );
  }

  goToLink() {
    
    // @ts-ignore
    window.location = ItemModelUtil.getWrappedLink(this.typedItem);
  }
}
